import cn from 'classnames';
import styles from './audioIcon.module.scss';

export interface AudioIconProps {
    targetClass?: string;
    fillColor?: string;
}

export function AudioIcon({
    targetClass,
    fillColor = 'var(--base-contrast-subtle)',
}: AudioIconProps): React.JSX.Element {
    return (
        <span
            style={{ '--fill-color': fillColor } as React.CSSProperties}
            className={cn(styles.equalizer, targetClass)}
        >
            <span className={styles.bar} />
            <span className={styles.bar} />
            <span className={styles.bar} />
        </span>
    );
}
